import { setTheme } from "theme/default/setTheme";

export const setFontWeight500 = setTheme(({ theme }) => `font-weight: ${theme.fontWeightValues.font_weight_500}`);
